// Pump list search matches the pump name only.
// Serial number, model and pool name stay out of the match so a short
// numeric query does not list unrelated pumps.

export function pumpMatchesNameSearch(name, searchTerm) {
  const searchLower = String(searchTerm || '').toLowerCase().trim();
  if (!searchLower) {
    return true;
  }
  return String(name || '').toLowerCase().includes(searchLower);
}
